import { ComponentProps } from 'react';
import { vars } from 'src/core/themes';
import { IconsFill, UploadIcon } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';

import { ButtonWithIcon } from './ButtonWithIcon';

export const UploadButton = ({
  textContentId,
  iconOnlyMode,
  variant,
  ...props
}: Omit<ComponentProps<typeof ButtonWithIcon>, 'icon'>) => {
  return (
    <ButtonWithIcon
      {...props}
      icon={
        <UploadIcon
          withHoverEffect
          fill={
            iconOnlyMode || (variant && variant !== 'regular')
              ? variant === 'textPlain'
                ? IconsFill.textStrong
                : IconsFill.textBrand
              : IconsFill.textInverted
          }
          size={vars.iconSize.m}
        />
      }
      iconOnlyMode={iconOnlyMode}
      variant={variant}
      textColor={variant === 'textPlain' ? 'strong' : 'brand'}
      textContentId={textContentId || ContentId.Upload}
    />
  );
};
